import { useEffect, useMemo, useState } from 'react';

type ScreenType = 'sm' | 'md' | 'lg' | 'xl' | '2xl';

export const SCREENS = {
  SM: 'sm' as ScreenType,
  MD: 'md' as ScreenType,
  LG: 'lg' as ScreenType,
  XL: 'xl' as ScreenType,
  XXL: '2xl' as ScreenType,
};

export const BREAKPOINTS = {
  [SCREENS.SM]: 640,
  [SCREENS.MD]: 768,
  [SCREENS.LG]: 1024,
  [SCREENS.XL]: 1280,
  [SCREENS.XXL]: 1536,
};

const mediaStringBuilder = (breakpoint: number) => `(max-width: ${breakpoint}px)`;

export const useMediaQueries = (breakpoint: ScreenType) => {
  const mq = useMemo(
    () => window.matchMedia(mediaStringBuilder(BREAKPOINTS[breakpoint])),
    [breakpoint]
  );

  const [matchesMediaQuery, setMatchesMediaQuery] = useState(mq.matches);

  useEffect(() => {
    mq.addEventListener('change', (e) => {
      setMatchesMediaQuery(e.matches);
    });

    return () =>
      mq.removeEventListener('change', (e) => {
        setMatchesMediaQuery(e.matches);
      });
  }, [mq]);

  return [matchesMediaQuery, mq];
};
